import { MainMenuBox } from '@model-framework/menu/MenuBox';
import { MainMenuIcon } from '@model-framework/menu/MenuIcon';
import { faStrikethrough } from '@fortawesome/free-solid-svg-icons';

type Props = {
  menuSize: number;
  onClick(): void;
  text: string;
};

export const FontStrikethroughMenuButton: React.FC<Props> = ({ menuSize, onClick, text }: Props) => {
  return (
    <>
      <MainMenuBox menuSize={menuSize} isSelected={false} onClick={onClick} text={text} />
      <MainMenuIcon icon={faStrikethrough} menuSize={menuSize} />
    </>
  );
};
